stateProviders.push({
    name: 'schoolside.resources.information.faqs',
    url: '/faqs',
    templateUrl: 'fast/submodules/schoolside/resources/information/faqs/partials/faqs.html?v=' + versionNo,
    controller: 'faqsController',
    resolve: {
    	taxinfo: function(SchoolTaxModelService) {
      		return SchoolTaxModelService.get();
        },
        feeinfo: function(FeeAgreementModelService) {
            return FeeAgreementModelService.get();
        }
    }
});